var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_272_718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "url(#pattern0)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_272_718)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.31
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 28,
    height: 29,
    fill: "#A5A5A5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_272_718",
    transform: "matrix(0.0107527 0 0 0.0111111 0.016129 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_272_718",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACdUlEQVR4nO2cP2sUQRjGB22sRDuxTCVEREhrmVKrcPXC3TwPtyeHoEUaYa8R/BRJ1FobW+38Cn4B/6RVMIjGQGQg4BEvyW5u9p3szvODKY9758d777yzO3POCSGEEEIIIYS4uHjv7wJ4RfIryX0AX0jujMfj26lj6w0kn5A8IHl4fAD4Q/Jh6hg7D4DZIsELxtPUseYg+VCy7SRLtqFkyW4Cyc0lRatm10Wyu1VCwlDrZyE79Nne+9VaX5Y7WD6zt1PPIQvZAD65nMUBmBnJ/u1yBHPCjGR/drmBBaLalg3ghcsJnCKoRdkHo9HojssF1BDTkuzHLhfQ4KcO4HnEHWTlcgHnWLwiyZZkti9bktkssxvX7Kaf6TSI8zDoXJmdDYgoWbINJUu2oWTJNpScvWwYSs5WNhJIPhrqkynJyuROAZULSe4FUCZLci+AMlmSewGUyZLcC6BMluReAGWyJPcCZbIBkmyAJBsgyQZIsgGSbERZlisAHgH4oBepRoS7dyTftHwsYGY1nwuN9/6+jgQYMJlMbujchREkd3W4xQCSb3WCqFstX2URb+4LYpV6HjksiFXqOXSGsiyvk7wXNjMkXwL4KMlGDIfDmyQfnLSp0WYkMiRvqVycgPd+LaZszJUSZfIRVVVdCn+QGvP6Af61gFr45qSsx84+7/2qMvn/7NvK+mKNBUVRXCH5LftbTG0DYENXxgwA8PqMB/EqI8synU6vAvhZ462HZC8DgGHNbfNu7D47KwC8O0Xu99CNhNZvMBhcTh1rpwHw41iJ+BWeU4QFMnQjqePrDQCekdwj+T6UkaIorqWOSQghhBBCCCGEi8NfCAM6mcDjA9kAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisable);
export default __webpack_public_path__ + "static/media/editDisable.ee5b04c4ad6c993e9ca2ca9c5fec09ed.svg";
export { ForwardRef as ReactComponent };